import type { Rating, Ratings } from "./types";

const STORAGE_KEY = "my-country-philadelphia:ratings:v1";
const VALID_RATINGS = new Set<Rating>([0, 1, 2, 3, 4]);

export function loadLocalRatings(): Ratings {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    return sanitizeRatings(JSON.parse(raw) as unknown);
  } catch {
    return {};
  }
}

export function saveLocalRatings(ratings: Ratings): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(ratings));
  } catch {
    // Local persistence is a convenience. The app remains usable without it.
  }
}

export function clearLocalRatings(): void {
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // Nothing else to clear.
  }
}

export function sanitizeRatings(value: unknown): Ratings {
  if (!value || typeof value !== "object" || Array.isArray(value)) return {};
  const result: Ratings = {};
  for (const [key, rating] of Object.entries(value)) {
    const id = Number(key);
    if (Number.isInteger(id) && id >= 1 && id <= 159 && typeof rating === "number" && VALID_RATINGS.has(rating as Rating)) {
      result[String(id)] = rating as Rating;
    }
  }
  return result;
}
